var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"relative hbox items-center font-medium no-underline transition-colors",class:[
    _vm.dense ? 'min-h-11 gap-2 rounded-md px-2 text-base' : 'min-h-11 gap-3 rounded-lg px-3 text-base',
    _vm.active ? _vm.activeClass : _vm.inactiveClass,
    _vm.centered ? 'lg:justify-center lg:px-0' : '',
  ],attrs:{"href":_vm.href,"data-testid":_vm.testId,"data-active":_vm.active ? 'true' : null,"title":_vm.title},on:{"click":_vm.onClick}},[(_vm.active && _vm.showIndicator)?_c('span',{staticClass:"absolute left-0 top-1/2 h-5 w-1 -translate-y-1/2 rounded-r bg-navy"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }